module.exports = __webpack_public_path__ + "img/bdew-logo.b313ce98.svg";